export enum PlanningMode{
  EDITION='edition',
  VIEW='view'
}
